<!-- Toolbar -->
<medsurf-design-content-toolbar>
  <!-- Content -->
  <div class="p-toolbar-group-start">
    @if (appSharedFacade.currentSelectedBreadcrumbs$ | async; as breadcrumbs) {
      <div
        class="flex flex-1 flex-row align-items-center column-gap-2">
        @if (showNodeTreeButton) {
          <button medsurf-design-input-button
            [id]="'contents'"
            [title]="'global.contents' | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MENU"
          (click)="openNodeTreeModal()"></button>
        }
        @if (slideAuthorFacade.currentSelectedSlidePage$ | async) {
          <div
            class="flex">
            @if (slideAuthorFacade.previousAuthorSlideUrl$ | async; as previousUrl) {
              <button medsurf-design-input-button
                [id]="'previous_slide'"
                [title]="'global.slide_previous' | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LEFT"
              [routerLink]="['/' + previousUrl]"></button>
            }
            @if (slideAuthorFacade.nextAuthorSlideUrl$ | async; as nextUrl) {
              <button medsurf-design-input-button
                [id]="'next_slide'"
                [title]="'global.slide_next' | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT"
              [routerLink]="['/' + nextUrl]"></button>
            }
          </div>
        }
        <medsurf-design-content-breadcrumb [items]="breadcrumbs"></medsurf-design-content-breadcrumb>
        @if (slideAuthorFacade.currentSelectedSlidePage$ | async) {
          <div
            class="flex flex-row column-gap-2">
            @if (slideAuthorFacade.currentSelectedNode$ | async; as node) {
              <button medsurf-design-input-button
                [id]="'slide_copy_node'"
                [title]="'global.node_copy' | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.COPY"
              (click)="copySlide(node.id)"></button>
            }
            <medsurf-design-input-split-button [formField]="false"
              [name]="'slide_add_menu'"
              [tooltipLabel]="'global.slide_add' | translate"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PAGE_SLIDE"
              [iconClassAfter]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
              [items]="addSlideMenuItems"
            (buttonClick)="addSlide()"></medsurf-design-input-split-button>
          </div>
        }
      </div>
    }
  </div>
  <div class="p-toolbar-group-end">
    @if ({
      canRedo: historySharedFacade.canRedo$ | async,
      canUndo: historySharedFacade.canUndo$ | async
    }; as historyData) {
      <div
        class="flex flex-row flex-wrap align-items-center gap-2">
        @if ({
          currentSelectedSlidePage: slideAuthorFacade.currentSelectedSlidePage$ | async
        }; as slideData) {
          @if (slideData.currentSelectedSlidePage) {
            <medsurf-design-input-menu [formField]="false"
              [name]="'main_panel_display_menu'"
              [label]="'global.main_panel_display'"
              [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
              [buttonIconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.EYE_ARROW"
            [loadMenuItems]="getMainPanelDisplayMenuItems"></medsurf-design-input-menu>
          }
        }
        <button medsurf-design-input-button [id]="'undo'"
          [title]="'global.undo' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.UNDO"
          [disabled]="historyData.canUndo === false"
        (click)="executeUndo()"></button>
        <button medsurf-design-input-button [id]="'redo'"
          [title]="'global.redo' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REDO"
          [disabled]="historyData.canRedo === false"
        (click)="executeRedo()"></button>
        @if ({
          canSave: historySharedFacade.canSave$ | async
        }; as saveData) {
          <button medsurf-design-input-button [id]="'save_changes'"
            [label]="'global.save_changes' | translate"
            [inputClass]="(saveData.canSave === false ? FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY : FlatModels.ButtonDesignModels.ButtonDesignClass.WARNING)"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SAVE"
            [disabled]="saveData.canSave === false"
          (click)="executeSave()"></button>
          @if (slideAuthorFacade.currentSelectedRouteElement$ | async; as routeElement) {
            <button medsurf-design-input-button
              [id]="'preview'"
              [label]="(!saveData.canSave ? 'global.preview' : 'global.preview_save') | translate"
              [inputClass]="(saveData.canSave === false ? FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY : FlatModels.ButtonDesignModels.ButtonDesignClass.WARNING)"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PREVIEW"
            (click)="openNodePreview(routeElement)"></button>
          }
        }
      </div>
    }
  </div>
</medsurf-design-content-toolbar>
